module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-layout', {
    staticClass: "list-layout",
    attrs: {
      "pageSize": _vm.pageSize,
      "currentPage": _vm.currentPage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleChange,
      "size-change": _vm.handleSizeChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("委托出售收入列表")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "slot": "search-bar",
      "inline": true
    },
    slot: "search-bar"
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请输入物料名称/物料编码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.Search.Product),
      callback: function($$v) {
        _vm.Search.Product = $$v
      },
      expression: "Search.Product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择或输入品牌"
    },
    model: {
      value: (_vm.Search.BrandName),
      callback: function($$v) {
        _vm.Search.BrandName = $$v
      },
      expression: "Search.BrandName"
    }
  }, _vm._l((_vm.BrandNames), function(item) {
    return _c('el-option', {
      key: item.Name,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机型"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择或输入机型"
    },
    model: {
      value: (_vm.Search.ProductModel),
      callback: function($$v) {
        _vm.Search.ProductModel = $$v
      },
      expression: "Search.ProductModel"
    }
  }, _vm._l((_vm.ProductModels), function(item) {
    return _c('el-option', {
      key: item.Name,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择或输入模块"
    },
    model: {
      value: (_vm.Search.ProductModule),
      callback: function($$v) {
        _vm.Search.ProductModule = $$v
      },
      expression: "Search.ProductModule"
    }
  }, _vm._l((_vm.ProductModules), function(item) {
    return _c('el-option', {
      key: item.Name,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批次号"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "批次号"
    },
    model: {
      value: (_vm.Search.BatchCode),
      callback: function($$v) {
        _vm.Search.BatchCode = $$v
      },
      expression: "Search.BatchCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择或输入模块"
    },
    model: {
      value: (_vm.Search.Region),
      callback: function($$v) {
        _vm.Search.Region = $$v
      },
      expression: "Search.Region"
    }
  }, _vm._l((_vm.Regions), function(item) {
    return _c('el-option', {
      key: item.Name,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "slot": "tabs"
    },
    slot: "tabs"
  }, [_c('el-tabs', {
    staticClass: "tab",
    attrs: {
      "value": _vm.activename
    },
    on: {
      "tab-click": _vm.handleTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待收款",
      "name": "wait"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已收款",
      "name": "have"
    }
  })], 1), _vm._v(" "), (_vm.activename == 'wait') ? _c('div', {
    staticClass: "payment_box"
  }, [_vm._v("\n      待收款：" + _vm._s(_vm._f("amount")(_vm.waitTotalAmount)) + "\n    ")]) : _c('div', {
    staticClass: "payment_box"
  }, [_vm._v("\n      已收款：" + _vm._s(_vm._f("amount")(_vm.haveTotalAmount)) + "\n    ")])], 1), _vm._v(" "), _c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    staticClass: "sell_table",
    attrs: {
      "slot": "main-content",
      "element-loading-text": "加载中"
    },
    slot: "main-content"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("物料名称／编码")]), _vm._v(" "), _c('td', [_vm._v("客户物料名称／编码")]), _vm._v(" "), _c('td', [_vm._v("品项")]), _vm._v(" "), _c('td', [_vm._v("品牌")]), _vm._v(" "), _c('td', [_vm._v("机型")]), _vm._v(" "), _c('td', [_vm._v("模块")]), _vm._v(" "), _c('td', [_vm._v("数量")]), _vm._v(" "), _c('td', [_vm._v("出售时间")]), _vm._v(" "), _c('td', [_vm._v("操作")])])]), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
    return _c('tbody', [_c('div', {
      staticClass: "space_box"
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "first_td",
      attrs: {
        "colspan": "9"
      }
    }, [_c('span', [_vm._v("流水号：" + _vm._s(item.Code))]), _vm._v(" "), _c('span', [_vm._v("批次号：" + _vm._s(item.BatchCode))]), _vm._v(" "), _c('span', [_vm._v("应收金额：¥" + _vm._s(item.TotalAmount))]), _vm._v(" "), (_vm.activename == 'have') ? _c('span', [_vm._v("已收金额：¥" + _vm._s(item.ReceivedAmount))]) : _vm._e(), _vm._v(" "), (_vm.activename == 'wait') ? _c('span', [_vm._v("待收金额：¥" + _vm._s(item.TotalAmount - item.ReceivedAmount))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("区域：" + _vm._s(item.Area))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(item.ItemName)), _c('br'), _vm._v(" "), (item.ItemCode.length > 20) ? _c('p', [_vm._v("物料编码：" + _vm._s(item.ItemCode.substring(0, 20)))]) : _c('p', [_vm._v("物料编码：" + _vm._s(item.ItemCode))])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(item.ItemName)), _c('br'), _vm._v(" "), (item.ItemCode.length > 20) ? _c('p', [_vm._v("客户物料编码：" + _vm._s(item.ItemCode.substring(0, 20)))]) : _c('p', [_vm._v("客户物料编码：" + _vm._s(item.ItemCode))])]), _vm._v(" "), _c('td', [_c('el-tag', {
      attrs: {
        "type": _vm._f("ConditionColor")(item.ItemQualityName)
      }
    }, [_vm._v(_vm._s(item.ItemQualityName))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Machine))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Module))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(item.SalesTime, 'YYYY-MM-DD')))]), _vm._v(" "), _c('td', [_c('el-button', {
      attrs: {
        "type": "text",
        "size": "small"
      },
      nativeOn: {
        "click": function($event) {
          _vm.toDetail(item)
        }
      }
    }, [_vm._v("查看相关详情")])], 1)])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7de42a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Entrust/EntrustSellPage.vue
// module id = 765
// module chunks = 0